export const locales = ["en", "fa"] as const;

export type AppLocale = (typeof locales)[number];

export const defaultLocale: AppLocale = "en";

// Force prefixing all locales so URLs are explicit (e.g., /en, /fa).
export const localePrefix = "always" as const;

export function getDirection(locale: string): "ltr" | "rtl" {
  return locale === "fa" ? "rtl" : "ltr";
}
